import { useEffect, useState } from "react";
import axios from "axios";
import { EnvelopeSimple } from "@phosphor-icons/react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Categories from "@/components/site/Categories";
import Featured from "@/components/site/Featured";
import Machines from "@/components/site/Machines";
import MachineDialog from "@/components/site/MachineDialog";
import Industries from "@/components/site/Industries";
import CaseStudies from "@/components/site/CaseStudies";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import productsData from "@/data/products.json";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [products, setProducts] = useState(productsData);
  const [active, setActive] = useState(null);
  const [enquiryMachine, setEnquiryMachine] = useState("");
  const [machineFilter, setMachineFilter] = useState("All");

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => setProducts(res.data))
      .catch(() => {});
  }, []);

  const handleEnquire = (machine) => {
    setActive(null);
    setEnquiryMachine(machine.name);
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCategory = (filter) => {
    setMachineFilter(filter);
    document.getElementById("machines")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="home-page" className="bg-background text-foreground">
      <Navbar />
      <main>
        <Hero />
        <Categories onSelect={handleCategory} />
        <Featured products={products} onSelect={setActive} />
        <Machines products={products} onSelect={setActive} filter={machineFilter} setFilter={setMachineFilter} />
        <Industries />
        <CaseStudies />
        <About />
        <Contact products={products} enquiryMachine={enquiryMachine} />
      </main>
      <Footer />
      <MachineDialog machine={active} onClose={() => setActive(null)} onEnquire={handleEnquire} />
      <a
        href="#contact"
        data-testid="floating-inquiry-btn"
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-navy px-5 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-lg transition-colors duration-150 hover:bg-laser"
      >
        <EnvelopeSimple size={18} weight="bold" /> Inquiry
      </a>
    </div>
  );
}
